/** errorType values returned by the MPRN lookup endpoint on an unsuccessful
 *  response (PBUS-5). */
export enum MprnLookupErrorType {
  MprnLookupUnavailable = "MprnLookupUnavailable",
  InvalidMprn = "InvalidMprn",
}
